module.exports = __webpack_public_path__ + "static/media/29DUNON13.6f487a14.jpg";